import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Currency, DataTypeAvailableOptions, DataTypeOptions } from '@core/constants/data-types.constants';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-specific-expenditure',
  templateUrl: './specific-expenditure.component.html',
  styleUrls: ['./specific-expenditure.component.scss']
})
export class SpecificExpenditureComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() label = '';
  @Input() readonly = false;
  @Input() required = false;

  @Input() amountName = '';
  @Input() currencyOptions: DataTypeOptions<Currency> = [];
  @Input() amountLabel = '';

  @Input() typeName = '';
  @Input() typeLabel = '';
  @Input() typePlaceholder = '';
  @Input() typeOptions: DataTypeAvailableOptions = [];
  @Input() typeColor: 'primary' | 'light' = 'primary';

  @Input() removeLabel = '';
  @Input() removeFill: 'default' | 'clear' | 'outline' = 'clear';
  @Input() removeSize: 'medium' | 'small' | 'tiny' = 'tiny';
  @Input() removeIcon = 'assets/icons/delete.svg';
  @Input() removeIconPosition: 'left' | 'right' = 'left';
  @Output() removeItem = new EventEmitter();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  remove(): void {
    this.removeItem.emit();
  }
}
